import {
  REPORTED_INCIDENTS_CLEAR,
  REPORTED_INCIDENTS_CLEAR_FILTERS,
  REPORTED_INCIDENTS_SET_ON_REVIEW,
} from '../../../actions/actionTypes';

const defaultState = null;

const onReview = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case REPORTED_INCIDENTS_CLEAR:
    case REPORTED_INCIDENTS_CLEAR_FILTERS:
      return defaultState;

    case REPORTED_INCIDENTS_SET_ON_REVIEW:
      return payload?.onReview;

    default:
      return state;
  }
};

export default onReview;
